import tablesSlice from './tablesSlice';

export * from './thunks';

export default tablesSlice;
